import AccessibleIcon from '@material-ui/icons/Accessible';
export const BeperkingIcon = AccessibleIcon;

